import React from 'react';
import SubscriptionTier from './SubscriptionTier';
import { subscriptionTiers } from './constants';

const PricingGrid = () => {
  return (
    <div>
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4">Choose Your Subscription Plan</h1>
        <p className="text-lg max-w-2xl mx-auto">
          Select the plan that works best for your needs. All plans include our core features with different levels of support and capacity.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-8">
        {subscriptionTiers.map((tier, index) => (
          <SubscriptionTier
            key={index}
            tier={tier.tier}
            lookupKey={tier.lookupKey}
            price={tier.price}
            features={tier.features}
            buttonText={tier.buttonText}
            isPopular={tier.isPopular}
          />
        ))}
      </div>
      
      <div className="mt-16 text-center">
        <h2 className="text-2xl font-bold mb-4">Questions about our pricing?</h2>
        <p className="max-w-2xl mx-auto mb-6">
          We're happy to help you find the right plan for your needs. Contact our sales team for more information or custom enterprise solutions.
        </p>
        <button className="btn btn-outline">Contact Support</button>
      </div>
    </div>
  );
};

export default PricingGrid;
